/**
 * Component-owned chip styling for PictProvider-ChipTooltips.
 *
 * The chip color/structure palette (and its theme variants) lives in the
 * headlight-styles Bulma layer (`bulma-chip.scss`), authored with the
 * `--bulma-*` design tokens. This file holds only the small set of rules that
 * belong with the runtime behavior: the keyboard-focus affordance for the chip
 * button-anchor and the tooltip body layout.
 */
module.exports = /*css*/`
.chip:focus-visible
{
	outline: 2px solid var(--bulma-link, #485fc7);
	outline-offset: 1px;
}

.chip-tooltip
{
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
	white-space: nowrap;
}

.chip-tooltip .fa
{
	opacity: 0.85;
}

/* Chip tooltips must sit BELOW open Select2 dropdowns (z-index 30 in
   headlight-styles' bulma-select2) and other menus/overlays — a hover or pinned
   chip tooltip should never cover an open dropdown list. The shared
   .pict-modal-tooltip z-index (1020) is tuned for tooltips inside modal dialogs;
   chip tooltips live on form labels and only need to clear page content, so the
   chip-tooltip-bubble marker (added to every chip tooltip) scopes a lower value. */
.pict-modal-tooltip.chip-tooltip-bubble
{
	z-index: 20;
}

/* Theme the tooltip bubble (and its arrow, which reads --pict-modal-tooltip-bg)
   to the chip's color variant — a darker, saturated take on the chip color with
   a light same-hue label. PictProvider-ChipTooltips passes chip-tooltip-<variant>
   derived from the chip's is-<variant> class; unknown/default chips keep the
   standard dark tooltip. Uses the Bulma color tokens so it tracks the theme. */
.pict-modal-tooltip.chip-tooltip-primary
{
	--pict-modal-tooltip-bg: var(--bulma-primary-40);
	--pict-modal-tooltip-fg: var(--bulma-primary-95);
}
.pict-modal-tooltip.chip-tooltip-link
{
	--pict-modal-tooltip-bg: var(--bulma-link-40);
	--pict-modal-tooltip-fg: var(--bulma-link-95);
}
.pict-modal-tooltip.chip-tooltip-info
{
	--pict-modal-tooltip-bg: var(--bulma-info-40);
	--pict-modal-tooltip-fg: var(--bulma-info-95);
}
.pict-modal-tooltip.chip-tooltip-success
{
	--pict-modal-tooltip-bg: var(--bulma-success-40);
	--pict-modal-tooltip-fg: var(--bulma-success-95);
}
.pict-modal-tooltip.chip-tooltip-warning
{
	--pict-modal-tooltip-bg: var(--bulma-warning-40);
	--pict-modal-tooltip-fg: var(--bulma-warning-95);
}
.pict-modal-tooltip.chip-tooltip-danger
{
	--pict-modal-tooltip-bg: var(--bulma-danger-40);
	--pict-modal-tooltip-fg: var(--bulma-danger-95);
}
`;
